"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DataTable = exports.DATA_TABLE_BREAKPOINT = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _Checkbox = require("b2b-components/theme/components/Form/Checkbox/Checkbox");
var _getComponentDataAttributes = require("b2b-components/utils/getComponentDataAttributes");
var _key = require("b2b-components/utils/key");
var _classnames = _interopRequireDefault(require("classnames"));
var _upperCase = require("upper-case");
var _AddRowButton = require("./AddRowButton");
var _Body = require("./Body");
var _Row = require("./Body/Row");
var _Cell = require("./Body/Row/Cell");
var _Head = require("./Head");
var _Row2 = require("./Head/Row");
var _Cell2 = require("./Head/Row/Cell");
require("./DataTable.scss");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var DATA_TABLE_BREAKPOINT = /*#__PURE__*/function (DATA_TABLE_BREAKPOINT) {
  DATA_TABLE_BREAKPOINT["xs"] = "xs";
  DATA_TABLE_BREAKPOINT["sm"] = "sm";
  DATA_TABLE_BREAKPOINT["md"] = "md";
  DATA_TABLE_BREAKPOINT["lg"] = "lg";
  return DATA_TABLE_BREAKPOINT;
}(DATA_TABLE_BREAKPOINT || {});
exports.DATA_TABLE_BREAKPOINT = DATA_TABLE_BREAKPOINT;
var DataTable = function DataTable(_ref) {
  var _classNames;
  var addedRows = _ref.addedRows,
    areRowsRemovable = _ref.areRowsRemovable,
    breakpoint = _ref.breakpoint,
    className = _ref.className,
    createAddButton = _ref.createAddButton,
    createDeleteButton = _ref.createDeleteButton,
    currentRowIndexes = _ref.currentRowIndexes,
    dataAttributes = _ref.dataAttributes,
    header = _ref.header,
    isRowAddable = _ref.isRowAddable,
    onRowMouseEnter = _ref.onRowMouseEnter,
    onRowMouseLeave = _ref.onRowMouseLeave,
    rows = _ref.rows,
    selectableOptions = _ref.selectableOptions,
    _ref$isHoverable = _ref.isHoverable,
    isHoverable = _ref$isHoverable === void 0 ? false : _ref$isHoverable,
    _ref$isSelectable = _ref.isSelectable,
    isSelectable = _ref$isSelectable === void 0 ? false : _ref$isSelectable,
    _ref$maxRows = _ref.maxRows,
    maxRows = _ref$maxRows === void 0 ? Number.MAX_SAFE_INTEGER : _ref$maxRows;
  var AddRowButton = DataTable.AddRowButton,
    Body = DataTable.Body,
    BodyCell = DataTable.BodyCell,
    BodyRow = DataTable.BodyRow,
    Head = DataTable.Head,
    HeadCell = DataTable.HeadCell,
    HeadRow = DataTable.HeadRow;
  var rootClassName = (0, _classnames["default"])('cds-DataTable', 'cds-Table--Bordered', 'cds-Table–-FullWidth', (_classNames = {
    'cds-DataTable--Selectable': isSelectable
  }, (0, _defineProperty2["default"])(_classNames, "cds-DataTable--MobileBreakpoint".concat((0, _upperCase.upperCase)(breakpoint || '') || ''), breakpoint), (0, _defineProperty2["default"])(_classNames, 'cds-Table--Hoverable', isHoverable), _classNames), className);
  var createRow = (0, _react.useCallback)(function (row, index) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
      key: (0, _key.createKey)(index, 'BodyRow')
    }, /*#__PURE__*/_react["default"].createElement(BodyRow, {
      className: row.className,
      hasSubRow: !!row.subRow,
      onClick: row.onClick,
      onMouseEnter: onRowMouseEnter(row.onMouseEnter, {
        hasSubRow: !!row.subRow
      }),
      onMouseLeave: row.subRow && onRowMouseLeave({
        hasSubRow: true
      })
    }, isSelectable && /*#__PURE__*/_react["default"].createElement(BodyCell, {
      className: "cds-DataTable-BodyCell--Checkbox",
      mobileOrder: 0,
      value: row.selectableValue !== undefined ? /*#__PURE__*/_react["default"].createElement(_Checkbox.Checkbox, {
        isChecked: selectableOptions && selectableOptions.isOptionChecked(row.selectableValue),
        onChange: function onChange() {
          selectableOptions && selectableOptions.onOptionChange(row.selectableValue);
        }
      }) : null
    }), row.cells.map(function (cell, index) {
      return /*#__PURE__*/_react["default"].createElement(BodyCell, {
        className: cell.className,
        isTextTruncate: cell.isTextTruncate,
        key: (0, _key.createKey)(index, 'BodyCell'),
        mobileLabel: header && header[index].mobileLabel,
        mobileOrder: cell.mobileOrder,
        value: cell.value
      });
    }), areRowsRemovable && /*#__PURE__*/_react["default"].createElement(BodyCell, {
      value: createDeleteButton(index)
    })), row.subRow && /*#__PURE__*/_react["default"].createElement(BodyRow, {
      className: row.className,
      isSubRow: true,
      onClick: row.onClick,
      onMouseEnter: onRowMouseEnter(row.onMouseEnter, {
        isSubRow: true
      }),
      onMouseLeave: onRowMouseLeave({
        isSubRow: true
      })
    }, /*#__PURE__*/_react["default"].createElement(BodyCell, {
      className: row.subRow ? row.subRow.className : '',
      colspan: isSelectable ? row.cells.length + 1 : row.cells.length,
      value: row.subRow && row.subRow.value || ''
    }), areRowsRemovable && /*#__PURE__*/_react["default"].createElement(BodyCell, {
      value: ""
    })));
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [areRowsRemovable, createDeleteButton, header, isSelectable, onRowMouseEnter, onRowMouseLeave, selectableOptions]);
  var isRowNotRemoved = (0, _react.useCallback)(function (index) {
    return currentRowIndexes.includes(index);
  }, [currentRowIndexes]);
  if (!Array.isArray(rows)) {
    return null;
  }
  var bodyRows = rows.reduce(function (total, row, index) {
    if (isRowNotRemoved(index) && total.length < maxRows) {
      total.push(createRow(row, index));
    }
    return total;
  }, []);
  var addedBodyRows = addedRows.reduce(function (total, row, index) {
    var addedRowIndex = index + rows.length;
    if (isRowNotRemoved(addedRowIndex) && total.length < maxRows - bodyRows.length) {
      total.push(createRow(row, addedRowIndex));
    }
    return total;
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("table", (0, _extends2["default"])({}, (0, _getComponentDataAttributes.getComponentDataAttributes)(dataAttributes), {
    className: rootClassName
  }), header && /*#__PURE__*/_react["default"].createElement(Head, null, /*#__PURE__*/_react["default"].createElement(HeadRow, null, isSelectable && /*#__PURE__*/_react["default"].createElement(HeadCell, {
    className: "cds-DataTable-HeadCell--Checkbox",
    value: /*#__PURE__*/_react["default"].createElement(_Checkbox.Checkbox, {
      isChecked: selectableOptions && selectableOptions.isCheckboxChecked,
      isRemoveMode: selectableOptions && selectableOptions.isCheckboxRemoveMode,
      onChange: selectableOptions && selectableOptions.onCheckboxChange
    })
  }), header && header.map(function (cell, index) {
    return /*#__PURE__*/_react["default"].createElement(HeadCell, {
      className: cell.className,
      key: (0, _key.createKey)(index, 'HeadCell'),
      value: cell.value
    });
  }), areRowsRemovable && /*#__PURE__*/_react["default"].createElement(HeadCell, {
    value: ""
  }))), /*#__PURE__*/_react["default"].createElement(Body, null, bodyRows, addedBodyRows)), isRowAddable && currentRowIndexes.length < maxRows && /*#__PURE__*/_react["default"].createElement(AddRowButton, {
    button: createAddButton()
  }));
};
exports.DataTable = DataTable;
DataTable.AddRowButton = _AddRowButton.AddRowButton;
DataTable.Body = _Body.Body;
DataTable.BodyCell = _Cell.Cell;
DataTable.BodyRow = _Row.Row;
DataTable.Head = _Head.Head;
DataTable.HeadCell = _Cell2.Cell;
DataTable.HeadRow = _Row2.Row;
DataTable.config = {
  breakpoint: DATA_TABLE_BREAKPOINT
};